import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { toast } from 'react-toastify'; // Assurez-vous que react-toastify est installé

import step1Img from 'assets/images/step1.PNG'; // Import local de vos images
import step2Img from 'assets/images/step2.PNG';
import step3Img from 'assets/images/step3.PNG';
import step4Img from 'assets/images/step4.PNG';
import step5Img from 'assets/images/step5.PNG';
import { useParams } from 'react-router-dom';

const SyncEventId = () => {
    const { id } = useParams()
    const [showlink, setShowLink] = useState(false);
    const [link, setLink] = useState('');

    const handleShowLink = () => {
        setLink(`https://us-central1-bohouse-1.cloudfunctions.net/generateIcalu?id=${id}`);
        setShowLink(true);

    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(link)
            .then(() => {
                toast.success("Lien copié dans le presse-papiers !");
            })
            .catch(() => {
                toast.error("Échec de la copie du lien");
            });
    };

    return (
        <Card>
            <Card.Body>
                {/* Titre */}
                <h4 className="text-center mb-4">S'abonner au calendrier de MENAGE</h4>
                <br />
                <p className="text-muted">Sur votre <b>android</b> il est nécessaire de faire l'importation sur un ordinateur de bureau depuis Google Calendar avec un compte google en copiant le lien en bas de page, en important le lien dans Google Calendar qui le synchonisera automatiquement ensuite avec votre smartphone (installation Google Agenda et le même compte google).</p>
                {/* Instructions */}
                <p className="text-muted">
                    Voici comment s'abonner au calendrier depuis l'application Calendrier sur un iPhone :
                </p>
                <ol className="text-muted">
                    <li>
                        Copiez le lien d'abonnement en cliquant sur le bouton "Afficher votre lien" <i style={{ color: 'blue' }}>tout en bas</i> puis "Copier le lien".
                    </li>
                    <li>
                        Ouvrez l'application <b>Calendrier</b> sur votre appareil.
                    </li>
                    <li>
                        <img src={step1Img} alt="Étape 1 : Copier le lien" className="img-fluid mt-2 mb-3" />
                    </li>
                    <li>
                        <img src={step2Img} alt="Étape 1 : Copier le lien" className="img-fluid mt-2 mb-3" />
                    </li>
                    <li>
                        <img src={step3Img} alt="Étape 1 : Copier le lien" className="img-fluid mt-2 mb-3" />
                    </li>
                    <li>Collez le lien dans le champ prévu et cliquez sur <b>S'abonner</b>.</li>
                    <img src={step4Img} alt="Étape 2 : Ouvrir Calendrier" className="img-fluid mt-2 mb-3" />
                    <li>
                        Configurez les options d'abonnement (actualisation, couleur, etc.) selon vos préférences, puis cliquez
                        sur <b>OK</b>.
                        <img src={step5Img} alt="Étape 3 : Ajouter un abonnement" className="img-fluid mt-2 mb-3" />
                    </li>
                </ol>
                <p className="text-muted">Votre calendrier Ménage est désormais synchronisé sur votre appareil.</p>

                {/* Lien d'abonnement */}
                <Row className="flex-center">
                    <Col md="auto" className="mt-4 mt-md-0">
                        <Flex>
                            {showlink ? (
                                <div>
                                    <p>{link}</p>
                                    <IconButton
                                        className="me-2"
                                        variant="falcon-primary"
                                        size="sm"
                                        onClick={handleCopyLink}
                                    >
                                        Copier le lien
                                    </IconButton>
                                </div>
                            ) : (
                                <IconButton
                                    className="me-2"
                                    variant="falcon-default"
                                    size="sm"
                                    onClick={handleShowLink}
                                >
                                    Afficher votre lien
                                </IconButton>
                            )}
                        </Flex>
                    </Col>
                </Row>
               


            </Card.Body>
        </Card>
    );
};

export default SyncEventId;